import { module } from 'angular';
import { CoreProvidersModule } from './providers/core-providers.module';
import { CoreServicesModule } from './services/core-services.module';
import { httpConfig, storageConfig } from './config';
import { CoreConstantsModule } from './constants/constants.module';
import { CoreInterceptorsModule } from './interceptors/core-interceptors.module';

export const CoreModule = module('app.core', [
  CoreConstantsModule.name,
  CoreProvidersModule.name,
  CoreServicesModule.name,
  CoreInterceptorsModule.name
])
  .config(storageConfig)
  .config(httpConfig).name;



// WEBPACK FOOTER //
// ./app/core/core.module.ts